module.exports = __webpack_public_path__ + "static/media/new-visa-mastercard-logo.21e5e4d0.png";